import { useStore } from "@/context/StoreContext";

export default function Toast() {
  const { toastMsg } = useStore();

  return (
    <div className={`toast ${toastMsg ? "show" : ""}`} data-testid="toast" role="status">
      {toastMsg}
    </div>
  );
}
